/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum JiraDataCenterAlertDescriptionAttribute {
    cloud = 'cloud',
    project_name = 'project_name',
    classification = 'classification',
    sub_classification = 'sub_classification',
    alert_type = 'alert_type',
    cost_impact = 'cost_impact',
    created_date = 'created_date',
    baseline_value = 'baseline_value'
}
